import { Box, Button, Link, List, ListItem, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material'
import useStyles from '../styles/Thanx.styles'
import ImageCamera from '../../../assets/images/camera.png'
import ImageHeadset from '../../../assets/images/headset.png'
import ImageCar from '../../../assets/images/car.png'
import LikeButton from '../components/LikeButton'
import { ThanksProps } from '../types'
import HelpIcon from '@mui/icons-material/Help'
import TagManager from 'react-gtm-module'
import { useHelpText } from '../../../api/texts/hooks'

const ThanxView: React.FC<ThanksProps> = ({ interests, handleSetInterest }) => {
    const classes = useStyles()
    const { data: thanksHeadingText } = useHelpText('USER_THANKS')

    const handleBackToZZ = () => {
        TagManager.dataLayer({
            dataLayer: {
                event: 'clickCustomerZone',
            },
        })
        if (process.env.REACT_APP_ZZ) window.location.href = process.env.REACT_APP_ZZ
    }
    return (
        <Box maxWidth={625} marginTop='50px'>
            <Paper>
                <Box p={3} textAlign='center'>
                    <Box p={1}>
                        <Typography variant='h4'>DĚKUJEME ZA VYPLNĚNÍ!</Typography>
                    </Box>
                    <Box p={1}>
                        {thanksHeadingText && <Typography dangerouslySetInnerHTML={{ __html: thanksHeadingText }}></Typography>}
                    </Box>
                    <Box p={1}>
                        <List>
                            <ListItem
                                secondaryAction={
                                    <Link target='_blank' href='https://www.bezpecnostnicentrum.cz/cs/videosluzby'>
                                        <HelpIcon></HelpIcon>
                                    </Link>
                                }
                            >
                                <ListItemIcon>
                                    <img src={ImageCamera} alt='Camera'></img>
                                </ListItemIcon>
                                <ListItemText className={classes.listItemText}>Videoslužby</ListItemText>
                                <LikeButton
                                    isRegistered={interests.videoServicesInterest}
                                    onClick={() => {
                                        TagManager.dataLayer({
                                            dataLayer: {
                                                event: 'clickVideo',
                                            },
                                        })
                                        handleSetInterest('videoServicesInterest')
                                    }}
                                />
                            </ListItem>
                            <ListItem
                                secondaryAction={
                                    <Link target='_blank' href='https://www.bezpecnostnicentrum.cz/cs/audiovyzva'>
                                        <HelpIcon></HelpIcon>
                                    </Link>
                                }
                            >
                                <ListItemIcon>
                                    <img src={ImageHeadset} alt='Headset'></img>
                                </ListItemIcon>
                                <ListItemText className={classes.listItemText}>Audioslužby</ListItemText>
                                <LikeButton
                                    isRegistered={interests.audioServicesInterest}
                                    onClick={() => {
                                        TagManager.dataLayer({
                                            dataLayer: {
                                                event: 'clickAudio',
                                            },
                                        })
                                        handleSetInterest('audioServicesInterest')
                                    }}
                                />
                            </ListItem>
                            <ListItem
                                secondaryAction={
                                    <Link target='_blank' href='https://www.bezpecnostnicentrum.cz/cs/strezeni-vozidel'>
                                        <HelpIcon></HelpIcon>
                                    </Link>
                                }
                            >
                                <ListItemIcon>
                                    <img src={ImageCar} alt='Car'></img>
                                </ListItemIcon>
                                <ListItemText className={classes.listItemText}>Střežení vozidel</ListItemText>
                                <LikeButton
                                    isRegistered={interests.carSecurityInterest}
                                    onClick={() => {
                                        TagManager.dataLayer({
                                            dataLayer: {
                                                event: 'clickCar',
                                            },
                                        })
                                        handleSetInterest('carSecurityInterest')
                                    }}
                                />
                            </ListItem>
                            {/* <ListItem
                                secondaryAction={
                                    <Link target='_blank' href='https://www.jablotronsos.cz/'>
                                        <HelpIcon></HelpIcon>
                                    </Link>
                                }
                            >
                                <ListItemIcon>
                                    <img src={ImagePerson} alt='Car'></img>
                                </ListItemIcon>
                                <ListItemText className={classes.listItemText}>Osobní bezpečnost</ListItemText>
                                <LikeButton
                                    isRegistered={interests.personSecurityInterest}
                                    onClick={() => {
                                        TagManager.dataLayer({
                                            dataLayer: {
                                                'event': 'clickPersonal',
                                            }
                                        });
                                        handleSetInterest('personSecurityInterest')
                                    }}
                                />
                            </ListItem> */}
                        </List>
                    </Box>
                    <Box p={1}>
                        <Button color='primary' variant='contained' onClick={() => handleBackToZZ()}>
                            Zpět do zákaznické zóny
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Box>
    )
}

export default ThanxView
